
import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import { ENDPOINTS } from '../config';

const NotesModal = ({ open, onClose, quote, onSave, onShowSuccess, getAuthHeaders }) => {  // ✅ Add getAuthHeaders prop
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (quote) {
      setNotes(quote.internalNotes || "");
    }
  }, [quote]);

  const handleSave = async () => {
    if (!quote || !quote.id) return;

    try {
        const response = await fetch(`${ENDPOINTS.QUOTES}/${quote.id}`, {
            method: 'PATCH', 
            headers: getAuthHeaders(),  // ✅ USE THE HELPER FUNCTION
            body: JSON.stringify({ internalNotes: notes }), 
        });

        if (!response.ok) {
            throw new Error(`Server responded with ${response.status}`);
        }

        onShowSuccess("Notes updated successfully!");
        onSave(quote.id, notes); 
        onClose();

    } catch (error) {
        console.error("Failed to save notes:", error);
        alert("There was an error saving the notes. Please try again.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Notes for {quote?.customer?.name}</DialogTitle>  {/* ✅ Also fixed this - see note below */}
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="notes"
          label="Add your notes here..."
          type="text"
          fullWidth
          multiline
          rows={6}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotesModal;